export function isLibraryBuild(): boolean {
    const { REACT_APP_BUILD_TARGET } = import.meta.env;
    return REACT_APP_BUILD_TARGET === "lib" || REACT_APP_BUILD_TARGET === "lib-as-app";
}

export function isStrictLibraryBuild(): boolean {
    const { REACT_APP_BUILD_TARGET } = import.meta.env;
    return REACT_APP_BUILD_TARGET === "lib";
}

export function isAppBuild(): boolean {
    const { REACT_APP_BUILD_TARGET } = import.meta.env;
    return REACT_APP_BUILD_TARGET === "app";
}
